import { saveCookie } from './cookie'

const saveFmpFunnelCookie = (cookieName: string, timestamp: string) => {
  saveCookie(cookieName, timestamp)
}

export default saveFmpFunnelCookie
